<p>success-new-wallet-step works!</p>
